import { PropsWithChildren } from "react";
import { cn } from "web-design-system";

export function CalculatorResultContainer(
  props: PropsWithChildren<{ className?: string }>
) {
  return (
    <div
      className={cn(
        "relative rounded-lg group bg-background flex flex-col items-center border border-secondary p-4 flex-1 min-w-0",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
